"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M7 16.3965C7 16.6195 6.73 16.7305 6.573 16.5735L3.427 13.4265C3.27 13.2695 3.381 13.0005 3.604 13.0005H6.75C6.888 13.0005 7 13.1115 7 13.2505V16.3965ZM11 6.0005C11.553 6.0005 12 6.4475 12 7.0005V17.0005C12 17.5525 11.553 18.0005 11 18.0005H6.858C6.594 18.0005 6.339 17.8945 6.151 17.7075L2.293 13.8485C2.105 13.6615 2 13.4065 2 13.1415V7.0005C2 6.4475 2.447 6.0005 3 6.0005H11ZM17.0654 2C17.5814 2 18.0004 2.418 18.0004 2.935V14.065C18.0004 14.582 17.5814 15 17.0654 15H13.2504C13.1124 15 13.0004 14.888 13.0004 14.75V5.935C13.0004 5.418 12.5814 5 12.0654 5H7.2504C7.1124 5 7.0004 4.888 7.0004 4.75V2.935C7.0004 2.418 7.4194 2 7.9344 2H17.0654Z",
    fill: "#727B7F"
  }));
};